/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import adhocTrait from '../../base/componentViewTrait/adhocTrait';

export default _.extend({}, adhocTrait, {
    _initComponent: function () {
        return adhocTrait._initComponent.apply(this, arguments);
    }
});